import reduxAblyMiddleware, { withCallbacks } from "_shared/_stores/realtime/redux-ably-middleware";
import { ablyChannelNamesForSession } from "_shared/_stores/realtime/ably-channel-names";

export const systemMessagesCallbacks = withCallbacks()
  .add("system-message-created", (payload: unknown) => () => {
    globalThis.dispatchEvent(new CustomEvent("system-message-created", { detail: payload }));
  })
  .add("system-message-deleted", (payload: unknown) => () => {
    globalThis.dispatchEvent(new CustomEvent("system-message-deleted", { detail: payload }));
  })
  .add("system-message-updated", (payload: unknown) => () => {
    globalThis.dispatchEvent(new CustomEvent("system-message-updated", { detail: payload }));
  });

export const systemMessagesAblyMiddleware = reduxAblyMiddleware({
  callbacks: systemMessagesCallbacks,
  channelName: ablyChannelNamesForSession.systemMessages,
  shouldConnectionStartImmediately: true,
});
